import { createSlice } from '@reduxjs/toolkit';
// utils
import axios from '../../utils/axios';
//
import { dispatch } from '../store';

// ----------------------------------------------------------------------

const initialState = {
  isSkillsLoading: false,
  error: null,
  skills: null,
};

const slice = createSlice({
  name: 'skill',
  initialState,
  reducers: {
    // START LOADING
    startSkillsLoading(state) {
      state.isSkillsLoading = true;
    },
    // HAS ERROR
    hasError(state, action) {
      state.isSkillsLoading = false;
      state.error = action.payload;
    },
    // GET FLEET
    setSkills(state, action) {
      state.isSkillsLoading = false;
      state.skills = action.payload;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const { startSkillsLoading, hasError } = slice.actions;

// ----------------------------------------------------------------------

export function getSkills(params = {}) {
  return async () => {
    dispatch(slice.actions.startSkillsLoading());
    try {
      await axios
        .get(`/admin/resource/skills`, {
          params: params,
        })
        .then((response) => {
          const { status, data } = response;
          if (status == 200) {
            dispatch(slice.actions.setSkills(data));
          }
        });
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
